import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FilesService } from 'src/app/core/services/files.service';

@Component({
  selector: 'file-text-show-view',
  templateUrl: './file-text-show-view.component.html',
  styleUrls: ['./file-text-show-view.component.scss'],
})
export class FileTextShowViewComponent implements OnInit {
  @Input() url: string = null;
  data: string[] = [];
  constructor(
      private readonly filesService: FilesService,
  ) {
  }
  ngOnInit(){
    this.loadTextContent();
  }
  async loadTextContent() {
    if (this.url) {
      const split = this.url.split('/');
      const name = split[split.length - 1];
      let dataAux = (await this.filesService
        .getFileByText(name)
        .toPromise());
      this.data = dataAux.split('\n');
    }
  }



}